import {
  WSText,
  WSForm,
  WSRadioInputGroup,
  WSButtons,
  WSButton
} from "@wingspanhq/fe-component-library";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { SetupFlowRouteComponentProps } from "../../components/SetupFlow/SetupFlow";
import { useUpdateActivity } from "../../query/activity";
import { useUserId } from "../../query/hooks/helpers";
import { useMissingInfoCollaboratorsQuery } from "../../query/payments/queries";
import { useActivities } from "../../query/users/queries";
import { get1099SetupProgress } from "../../query/users/selectors";
import { NEC1099FilingContainer } from "../components/NEC1099FilingContainer";

import styles from "./styles.module.scss";

export enum ImportCollaboratorsOptions {
  YES = "YES",
  NO = "NO"
}

export const NEC1099FilingImportCollaboratorsQuestion: React.FC<SetupFlowRouteComponentProps> = ({
  onBack,
  onNext
}) => {
  const history = useHistory();
  const userId = useUserId();
  const qActivity = useActivities(userId);
  const [importCollaborators, setImportCollaborators] = useState();
  const missingInfoCollaboratorsQuery = useMissingInfoCollaboratorsQuery();

  const [updateActivity, updateActivityMeta] = useUpdateActivity(userId);

  const onFormSubmit = async () => {
    if (importCollaborators === ImportCollaboratorsOptions.NO) {
      const nec1099SetupProgress = get1099SetupProgress(qActivity.data);
      await updateActivity({
        flows: {
          nec1099Setup: {
            ...nec1099SetupProgress,
            currentStep: 3
          }
        }
      });
    }
    onNext({
      shouldImportCollaborators:
        importCollaborators === ImportCollaboratorsOptions.YES,
      doMissingInfoCollaboratorsExists:
        (missingInfoCollaboratorsQuery.data || [])?.length > 0
    });
  };

  return (
    <NEC1099FilingContainer title="Add new collaborators">
      <WSText.Heading2 mb="M">
        Would you like to bulk import new collaborators who are not yet on
        Wingspan?
      </WSText.Heading2>
      <WSText.Paragraph color="grey700" mb="M">
        You will be able to import additional collaborators to be invited to
        Wingspan from a spreadsheet.
      </WSText.Paragraph>

      <WSForm onSubmit={onFormSubmit}>
        <WSRadioInputGroup
          mb="XL"
          name="hasOffPlatformPayments"
          onChange={(event: any) => {
            setImportCollaborators(event.target?.value);
          }}
          options={[
            {
              value: ImportCollaboratorsOptions.YES,
              label: "Yes, import new collaborators to Wingspan"
            },
            {
              value: ImportCollaboratorsOptions.NO,
              label: "No, everyone I paid is here already"
            }
          ]}
          optionHasBorder
          value={importCollaborators}
        />

        <WSButtons mt="XL">
          <WSButton.Secondary className={styles.actionBtn} onClick={onBack}>
            Back
          </WSButton.Secondary>
          <WSForm.SubmitButton
            className={styles.actionBtn}
            data-testid="hasOffPlatformPayments"
            loading={updateActivityMeta.isLoading}
            disabled={!importCollaborators}
          >
            Continue
          </WSForm.SubmitButton>
        </WSButtons>
      </WSForm>
    </NEC1099FilingContainer>
  );
};
